module.exports = __webpack_public_path__ + "static/media/x.5f6ea760.svg";